import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20collage%20of%20scattered%20fashion%20items%20including%20a%20cream%20sneaker%20a%20beige%20hoodie%20a%20tan%20leather%20bag%20sunglasses%20and%20a%20watch%20on%20a%20warm%20oatmeal%20linen%20background%2C%20soft%20natural%20window%20light%2C%20editorial%20minimalist%20style%2C%20clean%20modern%20aesthetic%2C%20no%20text%20no%20logos%2C%20elevated%20composition%2C%20creamy%20neutral%20tones&width=1600&height=1000&seq=hero-main-v3&orientation=landscape"
          alt="OOPBuy Spreadsheet product collage background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-white/85"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 md:px-6 pt-24 pb-16 w-full">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs md:text-sm font-medium text-primary-200 uppercase tracking-widest mb-4">
            Updated Weekly · 1000+ Products
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 drop-shadow-lg">
            OOPBuy Spreadsheet
            <br />
            <span className="text-white/85 font-normal">Updated Shopping List 2026</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
            Find the latest curated products and shopping lists with price comparison, shipping insights, and weekly fresh updates — all in one powerful spreadsheet.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer shadow-lg"
            >
              OOPBuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-950 bg-white/90 backdrop-blur-sm rounded-full hover:bg-white transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer shadow-lg"
            >
              Buy It Now
              <i className="ri-shopping-cart-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
            <div className="flex items-center gap-2 text-sm text-white/85">
              <i className="ri-check-line text-accent-400"></i>
              <span>Updated weekly spreadsheet</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85">
              <i className="ri-check-line text-accent-400"></i>
              <span>1000+ verified products</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85">
              <i className="ri-check-line text-accent-400"></i>
              <span>Price comparison included</span>
            </div>
          </div>

          <div className="mt-8">
            <Link
              to="/oopbuy-spreadsheet-guide"
              className="text-sm text-primary-200 hover:text-white font-medium underline underline-offset-4 transition-colors"
            >
              View Free Guide →
            </Link>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pb-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-background-50/90 backdrop-blur-sm rounded-2xl p-5 md:p-8 border border-background-200/70">
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-4 text-center">
              Latest OOPBuy Spreadsheet Preview
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="border-b border-background-300/60">
                    <th className="py-3 px-3 font-semibold text-foreground-800 whitespace-nowrap">Product Name</th>
                    <th className="py-3 px-3 font-semibold text-foreground-800 whitespace-nowrap">Category</th>
                    <th className="py-3 px-3 font-semibold text-foreground-800 whitespace-nowrap">Price</th>
                    <th className="py-3 px-3 font-semibold text-foreground-800 whitespace-nowrap">Rating</th>
                    <th className="py-3 px-3 font-semibold text-foreground-800 whitespace-nowrap">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                    <td className="py-3 px-3 text-foreground-700 font-medium">Streetwear Hoodie</td>
                    <td className="py-3 px-3 text-foreground-600">Fashion</td>
                    <td className="py-3 px-3 text-foreground-700 font-semibold">$29</td>
                    <td className="py-3 px-3">
                      <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                        <i className="ri-star-fill text-xs"></i> 9.2
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                        Available
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                    <td className="py-3 px-3 text-foreground-700 font-medium">Sneakers Model X</td>
                    <td className="py-3 px-3 text-foreground-600">Shoes</td>
                    <td className="py-3 px-3 text-foreground-700 font-semibold">$49</td>
                    <td className="py-3 px-3">
                      <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                        <i className="ri-star-fill text-xs"></i> 9.5
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                        Hot
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                    <td className="py-3 px-3 text-foreground-700 font-medium">Luxury Bag Style</td>
                    <td className="py-3 px-3 text-foreground-600">Accessories</td>
                    <td className="py-3 px-3 text-foreground-700 font-semibold">$89</td>
                    <td className="py-3 px-3">
                      <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                        <i className="ri-star-fill text-xs"></i> 8.8
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap">
                        Limited
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                    <td className="py-3 px-3 text-foreground-700 font-medium">Vintage T-Shirt</td>
                    <td className="py-3 px-3 text-foreground-600">T-Shirts</td>
                    <td className="py-3 px-3 text-foreground-700 font-semibold">$22</td>
                    <td className="py-3 px-3">
                      <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                        <i className="ri-star-fill text-xs"></i> 9.0
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                        Available
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-center mt-5">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                Unlock Full Spreadsheet Database
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}